import { ConfigService, getConfigService } from 'src/services';

import { AccountApplicationApi } from './AccountApplicationApi';
import { AccountHolderApi } from './AccountHolderApi';
import { AccountApi } from './AccountsApi';
import { BalanceApi } from './BalanceApi';
import { InvestigationsApi } from './InvestigationsApi';
import { OfferOrderApi } from './OfferOrderApi';
import { OrderApi } from './OrderApi';
import { PositionApi } from './PositionApi';
import { PrivateQuotesApi } from './PrivateQuotesApi';
import { QuoteApi } from './QuoteApi';
import { StatementsApi } from './StatementsApi';
import { SymbolApi } from './SymbolApi';

export class ClientApi {
  accountApplication: AccountApplicationApi;
  account: AccountApi;
  accountHolder: AccountHolderApi;
  balance: BalanceApi;
  investigations: InvestigationsApi;
  statements: StatementsApi;
  order: OrderApi;
  position: PositionApi;
  offerOrder: OfferOrderApi;
  privateQuotes: PrivateQuotesApi;
  quote: QuoteApi;
  symbol: SymbolApi;

  constructor(configService: ConfigService) {
    this.accountApplication = new AccountApplicationApi(configService);
    this.account = new AccountApi(configService);
    this.accountHolder = new AccountHolderApi(configService);
    this.balance = new BalanceApi(configService);
    this.investigations = new InvestigationsApi(configService);
    this.statements = new StatementsApi();
    this.order = new OrderApi();
    this.position = new PositionApi();
    this.offerOrder = new OfferOrderApi();
    this.privateQuotes = new PrivateQuotesApi();
    this.quote = new QuoteApi();
    this.symbol = new SymbolApi();
  }
}

const clientApi = new ClientApi(getConfigService());

export const getClientApi = () => {
  return clientApi;
};
